export const GET_ALL_BRANDS = "GET_ALL_BRANDS";
export const RESET_DATA = "RESET_DATA";
export const START_LOADING_BRANDS = "START_LOADING_BRANDS";
export const STOP_LOADING_BRANDS = "STOP_LOADING_BRANDS";
export const ERROR_LOADING_BRANDS = "ERROR_LOADING_BRANDS";